module.exports = __webpack_public_path__ + "../resources/img/lang_img4.817fca1b.png";